module.exports = __webpack_public_path__ + "static/media/blog5.5719df0e.jpg";